const TAKWEEN_SURVEY_FORM_ID_DEV = 'Wo3Hp6df';
const TAKWEEN_SURVEY_FORM_ID_PROD = 'PpVDH58M';

export const TAKWEEN_SURVEY_FORM_ID =
  import.meta.env.MODE === 'development' ? TAKWEEN_SURVEY_FORM_ID_DEV : TAKWEEN_SURVEY_FORM_ID_PROD;
